export const colors = {
  white: '#fff',
  veniceBlue: '#0b5394',
  onahau: '##BFEEFF',
  fire: '#a32800',
  romantic: '#FFD0BF',
  jewel: '##197140',
  aeroBlue: '##BFFFEA',
}



// WEBPACK FOOTER //
// ./src/colors.js